<template>
  <div class="row mt-0">
    <div class="col-12 col-md-6 col-lg-4">
      <atom-input
        v-model="smartHandFilter.idcId"
        :title="contractIdLabel"
        :placeholder="contractIdLabel"
        type="number"
        :maxLength="8"
      ></atom-input>
    </div>
    <div class="col-12 col-md-6 col-lg-4 mt-1 mt-md-0">
      <atom-input
        v-model="smartHandFilter.customerName"
        title="Customer Name"
        placeholder="Customer Name"
      ></atom-input>
    </div>
    <div class="col-12 col-lg-4 mt-1 mt-lg-0">
      <atom-select
        v-model="smartHandFilter.status"
        title="Status"
        placeholder="All Status"
        label="name"
        :option="smartHandStatusOption"
      ></atom-select>
    </div>
  </div>
</template>

<script>
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import mixins from '@/mixins'

export default {
  name: "MoleculeReportFilterSmartHand",
  components: { AtomSelect, AtomInput },
  mixins: [mixins],
  props: {
    value: {
      type: Object,
      required: true,
    },
    smartHandStatusOption: {
      type: Array,
      required: true,
    },
  },

  computed: {
    smartHandFilter: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },
}
</script>

<style></style>
